module.exports = __webpack_public_path__ + "img/epub-ic.7408f1fb.svg";